import { mutator } from 'satcheljs';
import store from '../store/Store';
import { focusedOtherPivotsToggled } from '../actions/internalActions';
import { InboxClassificationFilter } from 'owa-mail-list-store';

mutator(focusedOtherPivotsToggled, actionMessage => {
    for (let pivot of store.enabledDisabledPivots) {
        // Toggling the Focused/Other pivots swaps F/O with Inbox, so we need to toggle the
        // states of all 3
        if (
            pivot.InboxClassificationFilter === InboxClassificationFilter.Focused ||
            pivot.InboxClassificationFilter === InboxClassificationFilter.Other ||
            pivot.InboxClassificationFilter === InboxClassificationFilter.None
        ) {
            pivot.isEnabled = !pivot.isEnabled;
        }
    }
});
